<template>
    <div class="mian">
        <div class="page_box">
            <div class="page_box_right">
                <div class="layui-row layui-col-space10 " style="min-height: 500px;">
                    <div class="layui-col-md12">
                        <form class="layui-form">
                            <div class="layui-form-item">
                                <div class="layui-input-inline search-input">
                                    <input type="text" v-model="keyWords" placeholder="请输入培训计划关键字查询" autocomplete="off"
                                        class="layui-input">
                                </div>
                                <a class="layui-btn layui-btn-normal search-btn" @click="inquireData()">
                                    <i class="layui-icon layui-icon-search"></i>
                                    查询
                                </a>
                            </div>
                        </form>
                    </div>
                    <div v-for="(item,index) in trainList" :key="index" class="layui-col-md12 class-container">
                        <div class="class-item"><img class="class-item-img" src="../../../static/img/default-class.jpg">
                            <div class="class-item-content">
                                <h2 class="class-item-title">计划名称：{{item.className}}</h2>
                                <ul class="class-item-list">
                                    <li>计划期限：{{item.beginTime}}——<span style="color: red;">{{item.endTime}}</span>
                                    </li>
                                    <li>计划要求：<span
                                            style="color: red;">公需课{{item.publicPeriod}}课时、专业课{{item.professionalPeriod}}课时</span>
                                    </li>
                                    <li>学习人数：<span style="color: #49af4a;">{{item.userNum}}</span>
                                    </li>
                                </ul>

                                <a v-if="item.classType!=3&&item.graduationState==1&&item.joinState!=0&&item.choiceState==1"
                                    class="layui-btn join-class layui-btn-join">选课中...</a>

                                <a v-if="item.classType!=3&&item.graduationState==1&&item.joinState!=0&&item.choiceState==2"
                                    class="layui-btn join-class layui-btn-join">进行中</a>

                                <a v-if="item.classType!=3&&item.graduationState==2"
                                    class="layui-btn join-class layui-btn-join">已结束</a>


                            </div>
                        </div>
                    </div>

                    <div v-if="flag"
                        style="margin: auto;color:lightgray;font-size: 15px;text-align: center;padding-top: 200px;">暂无计划
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                trainList: [],
                flag: false,
                keyWords: ''
            }
        },
        created() {
            //加载数据
            this.loadData();

        },
        mounted() {

        },
        methods: {
            inquireData() {
                this.loadData();
            },
            loadData() {
                this.flag = false;
                let parames = new URLSearchParams();
                parames.append('keyWords', this.keyWords);

                parames.append('userId', this.$storage.get("declareUser").id);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/class/getClassData', parames).then(resp => {

                    if (resp.data.code === 1) {

                        resp.data.data.forEach(element => {
                            element.beginTime = element.beginTime.substring(0, 10)
                            element.endTime = element.endTime.substring(0, 10)
                        });

                        this.trainList = resp.data.data
                        if (resp.data.data.length <= 0) {
                            this.flag = true;
                        }
                    } else {
                        this.flag = true;
                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }


        }
    }
</script>

<style scoped>
    .class-item-list li {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 8px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .join-class {
        background-color: #C4261D;
        position: absolute;
        top: 89px;
        right: 142px;
    }

    .class-item-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 21px;
    }

    .class-item-content {
        display: inline-block;
        vertical-align: top;
        padding: 25px 0px;
    }

    .class-item-img {
        height: 180px;
        width: 287px;
        margin-right: 40px;
    }

    .class-item {
        height: 232px;
        width: 100%;
        border-radius: 9px;
        padding: 24px 38px;
        color: #333333;
        position: relative;
        margin-bottom: 25px;
        background-color: #fff;
        border: 1px solid #f0f0ee;
    }

    .layui-col-md12 {
        width: 100%;
    }

    .layui-col-space10>* {
        padding: 5px;
    }

    .layui-col-space10>* {
        padding: 5px;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .layui-btn .layui-icon {
        margin-right: 3px;
        font-size: 18px;
        vertical-align: bottom;
        vertical-align: middle\9;
    }

    .search-btn {
        width: 102px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        background-image: linear-gradient(to right, #63b9fd, #34dbf5);
        cursor: pointer;
    }

    .search-input input {
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        border: 1px solid #ddd;
        border-radius: 4px 0 0 4px;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    .search-input {
        width: 90% !important;
        margin: 1px !important;
    }

    .layui-form-item .layui-input-inline {
        float: left;
        width: 190px;
        margin-right: 10px;
    }

    .layui-form-item {
        margin-bottom: 0;
    }

    .layui-col-space10 {
        margin: -5px;
    }

    .page_box_right {
        width: 1280px;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        padding: 0 34px;
    }

    .f-cb:after,
    .f-cbli li:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .g-doc,
    .g-wrap,
    .g-flow,
    .g-all {
        width: 1205px;
        margin: 0 auto;
        text-align: left;
    }

    .m-breadcrumbBox {
        background: #fff;
    }

    .g-mn2 {
        float: left;
        width: 100%;
    }

    .m-breadcrumbBox {
        background-color: transparent;
        color: #666;
        font-size: 0;
        padding: 20px 0 20px 0;
    }

    .mian {
        min-width: 1200px;
        padding-top: 40px;
    }

    .page_box {
        width: 100%;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        clear: both;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/trainingPlan.vue